<template>
  <div class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col-12">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('complaints.breadcrumb_1')}}</router-link></li>
              <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
              <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-3 almarai-bold" aria-current="page">{{$t('complaints.complaintsReports')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row pt-3">
      <div class="col-12">
        <p>{{$t('complaints.Ahmed_AlMuhaisni_RealEstate')}}</p>
        <ul>
          <li>
            <span class="almarai-bold">{{$t('complaints.submittingComplaint')}}</span>
            <p>
              <span>{{$t('complaints.complaints_can_Submitted')}}</span>
              <span>
                <router-link class="contactUs" to="/contactUs">{{$t('complaints.contactUs')}}</router-link>
              </span>
            </p>
          </li>

          <li>
            <span class="almarai-bold">{{$t('complaints.processingResponse')}}</span>
            <p>{{$t('complaints.complaints_are_reviewed')}}</p>
          </li>

          <li>
            <span class="almarai-bold">{{$t('complaints.Escalation')}}</span>
            <p>{{$t('complaints.complaint_the_General')}}</p>
          </li>

          <li>
            <span class="almarai-bold">{{$t('complaints.scope_Liability')}}</span>
            <p>{{$t('complaints.companyLiability')}}</p>
          </li>

          <li>
            <span class="almarai-bold">{{$t('complaints.Abuse')}}</span>
            <p>{{$t('complaints.companyReserves')}}</p>
          </li>

          <li>
            <span class="almarai-bold">{{$t('complaints.complaint_Handling_Mechanism')}}</span>
            <p>{{$t('complaints.receivingComplaint')}}</p>
          </li>

          <li>
            <span class="almarai-bold">{{$t('complaints.reviewing_theComplaint')}}</span>
            <p>{{$t('complaints.specializedTeam')}}</p>
          </li>

          <li>
            <span class="almarai-bold">{{$t('complaints.communicatingParties')}}</span>
            <p>{{$t('complaints.whenNecessary')}}</p>
          </li>

          <li>
            <span class="almarai-bold">{{$t('complaints.actionTaken')}}</span>
            <p>{{$t('complaints.appropriateAction')}}</p>
          </li>

          <li>
            <span class="almarai-bold">{{$t('complaints.notificationComplainant')}}</span>
            <p>{{$t('complaints.complainant_notified')}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "complaints",
  data(){
    return{
      userLang: 'ar',
    }
  },
  created(){
    this.userLang = localStorage.getItem('lang') ??  'ar';
  }
}
</script>